/* Match native ProductVariantSelection: latest explicit choice, earlier choices,
   displayed-value matches, availability, then original catalogue order. */
(function () {
  'use strict';
  if (window.botNativeVariantResolution) return;
  var histories = new WeakMap();
  function normalized(value) { return String(value == null ? '' : value).trim().toLowerCase(); }
  function resolve(variants, selected, choices, index, value) {
    var candidates = variants.filter(function (variant) { return normalized(variant.options[index]) === normalized(value); });
    if (!candidates.length) return null;
    var nextChoices = choices.filter(function (choice) { return choice.index !== index; });
    nextChoices.push({ index: index, value: value });
    function better(candidate, current) {
      for (var i = nextChoices.length - 1; i >= 0; i--) {
        var choice = nextChoices[i];
        var a = normalized(candidate.options[choice.index]) === normalized(choice.value);
        var b = normalized(current.options[choice.index]) === normalized(choice.value);
        if (a !== b) return a;
      }
      var aScore = 0, bScore = 0;
      selected.forEach(function (option, at) {
        if (normalized(candidate.options[at]) === normalized(option)) aScore++;
        if (normalized(current.options[at]) === normalized(option)) bScore++;
      });
      if (aScore !== bScore) return aScore > bScore;
      if (candidate.available !== current.available) return candidate.available;
      return false;
    }
    var best = candidates[0];
    candidates.slice(1).forEach(function (candidate) { if (better(candidate, best)) best = candidate; });
    return { variant: best, choices: nextChoices };
  }
  window.botNativeVariantResolution = { resolve: resolve };
  document.addEventListener('change', function (event) {
    var target = event.target;
    var picker = target.closest && target.closest('variant-picker[data-bot-native-resolution]');
    if (!picker || !target.dataset || target.dataset.productUrl) return;
    var group = target.closest('[data-option-group]');
    if (!group || !target.hasAttribute('data-option-value-id')) return;
    var groups = Array.from(picker.querySelectorAll('[data-option-group]'));
    var index = groups.indexOf(group);
    var data = picker.querySelector('script[data-bot-variant-data]');
    if (index < 0 || !data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (_) { return; }
    // Liquid's unpaginated variants are capped: never choose from a partial catalogue.
    if (!Array.isArray(variants) || !variants.length || variants.length !== Number(picker.dataset.botVariantTotal)) return;
    if (!variants.every(function (variant) {
      return variant && /^\d+$/.test(String(variant.id)) && typeof variant.available === 'boolean' &&
        Array.isArray(variant.options) && variant.options.length === groups.length;
    })) return;
    var selected = variants.find(function (variant) { return String(variant.id) === picker.dataset.botSelectedVariant; }) ||
      variants.find(function (variant) { return variant.available; }) || variants[0];
    var history = histories.get(picker);
    if (!history || history.product !== picker.dataset.botProductId || history.catalogue !== data.textContent || history.variant !== String(selected.id)) {
      history = { product: picker.dataset.botProductId, catalogue: data.textContent, variant: String(selected.id), choices: [] };
    }
    var result = resolve(variants, selected.options, history.choices, index, target.value);
    if (!result) return;
    history.choices = result.choices;
    history.variant = String(result.variant.id);
    histories.set(picker, history);
    target.dataset.variantId = String(result.variant.id);
    // Keep this ID until the server-rendered option nodes replace it. A real user
    // event can run a microtask checkpoint between capture and bubbling listeners.
    // The existing handler performs the single request, price/DOM/URL update and
    // variant:change; no second event or cart action is introduced here.
  }, true);
})();
